module.exports = __webpack_public_path__ + "img/photos.3333613b.svg";